<template>

    <KedvezmenyekBase>

        <v-layout row wrap slot="kedvezmeny" ref="kedvezmeny" style="max-width: 100%;">

          <BnFormField :attributes="muszaki_vizsga_180_napon_belul"/>

        </v-layout>

    </KedvezmenyekBase>

</template>

<script>
import Kedvezmeny from '../../../../mixins/dijak/kedvezmenyek/Kedvezmeny';
import BnFormField from '../../../../../../basecomponents/BnFormField.vue';
import KedvezmenyekBase from '../KedvezmenyBase.vue';
import {MIKROMOBILITAS, ROLLER} from '../../../../../../../modules/Gepjarmu';
import { UJ } from '../../../../../../../modules/Const';

export default {
    name: 'KedvezmenyekB39',
    components: {
      KedvezmenyekBase,
      BnFormField,
    },
    mixins: [Kedvezmeny],
    methods: {
      muszakiVizsgaEditable() {
        return !this.disabled && this.$store.getters.tarifaData.ajanl_megkotok_type !== UJ && ![MIKROMOBILITAS, ROLLER].includes(this.$store.getters.gepjarmu.fajta);
      },
    },
    data() {
        return {
          muszaki_vizsga_180_napon_belul: {
            type: 'checkbox',
            label: 'Utolsó műszaki vizsga időpontja 180 napon belüli?',
            visible: true,
            editable: this.muszakiVizsgaEditable(),
            path: 'kedvezmenyekalaptabla.39.muszaki_vizsga_180_napon_belul',
            rules: [],
            help: true,
            mezo: 'muszaki_vizsga_180_napon_belul',
            change: this.shouldRecalc,
          },
        };
    },
};
</script>
